/* ============================================================
   YOOME THEME — Main JavaScript
   ============================================================ */

(function() {
  'use strict';

  // ---- Utility ----
  function $(selector, context) { return (context || document).querySelector(selector); }
  function $$(selector, context) { return Array.from((context || document).querySelectorAll(selector)); }
  function on(el, event, handler, options) { if (el) el.addEventListener(event, handler, options); }
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function withCommas(num) {
    var parts = String(num).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  }

  function formatMoney(cents) {
    var value = (cents || 0) / 100;
    var format = window.Yoome && window.Yoome.moneyFormat ? window.Yoome.moneyFormat : '${{amount}}';
    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommas(value.toFixed(2)))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, withCommas(Math.round(value)))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, String(Math.round(value)))
      .replace(/\{\{\s*amount\s*\}\}/g, withCommas(value.toFixed(2)));
  }

  // Shows cart problems to the shopper instead of only the console.
  function showCartError(message) {
    var old = document.getElementById('YoomeCartError');
    if (old) old.remove();
    var el = document.createElement('div');
    el.id = 'YoomeCartError';
    el.className = 'yoome-toast';
    el.setAttribute('role', 'alert');
    el.textContent = message;
    document.body.appendChild(el);
    requestAnimationFrame(function() { el.classList.add('is-visible'); });
    setTimeout(function() {
      el.classList.remove('is-visible');
      setTimeout(function() { if (el.parentNode) el.remove(); }, 400);
    }, 4000);
  }

  // ---- Cart State ----
  var cart = { items: [], item_count: 0, total_price: 0 };

  // ---- Cart Drawer ----
  var cartDrawer = $('#CartDrawer');
  var cartOverlay = $('#CartDrawerOverlay');
  var cartDrawerBody = $('#CartDrawerBody');
  var cartCount = $$('.cart-count');
  var cartSubtotal = $('#CartSubtotal');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        cart = data;
        renderCart(data);
        updateCartCount(data.item_count);
      })
      .catch(function(e) { console.error('Cart fetch error:', e); });
  }

  function renderCart(cartData) {
    if (!cartDrawerBody) return;
    if (cartData.item_count === 0) {
      cartDrawerBody.innerHTML = '<div class="cart-drawer__empty">' +
        '<svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>' +
        '<p>Your cart is empty</p>' +
        '<a href="/collections/all" class="btn btn--primary">Continue Shopping</a>' +
        '</div>';
    } else {
      var html = cartData.items.map(function(item) {
        return '<div class="cart-item" data-key="' + esc(item.key) + '">' +
          '<div class="cart-item__image"><a href="' + esc(item.url) + '"><img src="' + esc(item.image) + '" alt="' + esc(item.title) + '" loading="lazy"></a></div>' +
          '<div class="cart-item__info">' +
            '<div class="cart-item__title"><a href="' + esc(item.url) + '">' + esc(item.product_title) + '</a></div>' +
            (item.variant_title && item.variant_title !== 'Default Title' ? '<div style="font-size:1.2rem;color:rgba(26,31,46,0.5);margin-bottom:0.4rem;">' + esc(item.variant_title) + '</div>' : '') +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
            '<div class="cart-item__qty">' +
              '<button class="cart-item__qty-btn" data-action="decrease" data-key="' + item.key + '" aria-label="Decrease quantity">−</button>' +
              '<span class="cart-item__qty-count">' + item.quantity + '</span>' +
              '<button class="cart-item__qty-btn" data-action="increase" data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
              '<button class="cart-item__qty-btn" data-action="remove" data-key="' + item.key + '" aria-label="Remove item" style="margin-left:0.4rem;font-size:1.2rem;opacity:0.5;">✕</button>' +
            '</div>' +
          '</div>' +
        '</div>';
      }).join('');
      cartDrawerBody.innerHTML = html;
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cartData.total_price);
  }

  function updateCartCount(count) {
    cartCount.forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  function changeCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Could not update cart');
        return data;
      });
    })
    .then(function(data) { cart = data; renderCart(data); updateCartCount(data.item_count); })
    .catch(function(e) { showCartError(e.message || 'Could not update your cart.'); fetchCart(); });
  }

  // Cart event delegation
  on(cartDrawerBody, 'click', function(e) {
    var btn = e.target.closest('.cart-item__qty-btn');
    if (!btn) return;
    var key = btn.dataset.key;
    var action = btn.dataset.action;
    var item = cart.items.find(function(i) { return i.key === key; });
    if (!item) return;
    if (action === 'increase') changeCartItem(key, item.quantity + 1);
    else if (action === 'decrease') changeCartItem(key, Math.max(0, item.quantity - 1));
    else if (action === 'remove') changeCartItem(key, 0);
  });

  on($('#CartToggle'), 'click', openCart);
  on($('#CartDrawerClose'), 'click', closeCart);
  on(cartOverlay, 'click', closeCart);

  // ---- Add to Cart ----
  function addToCart(variantId, quantity, properties, btn) {
    if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1, properties: properties || {} })
    })
    .then(function(r) {
      return r.json().then(function(data) {
        // Shopify answers sold-out and over-stock with a 422 and a JSON error
        // body. Running the success path on that is what made the button say
        // "Added!" when nothing had been added.
        if (!r.ok) {
          var err = new Error(data.description || data.message || 'Could not add to cart');
          err.handled = true;
          throw err;
        }
        return data;
      });
    })
    .then(function() {
      if (btn) {
        btn.disabled = false;
        btn.textContent = 'Added!';
        setTimeout(function() { btn.textContent = btn.dataset.originalText || 'Add to Cart'; }, 1500);
      }
      if (window.Yoome && window.Yoome.cartType === 'drawer') openCart();
      else window.location.href = '/cart';
    })
    .catch(function(e) {
      if (btn) { btn.disabled = false; btn.textContent = btn.dataset.originalText || 'Add to Cart'; }
      showCartError(e && e.handled ? e.message : 'Sorry, we could not add that to your cart. Please try again.');
      if (!e || !e.handled) console.error('Add to cart error:', e);
    });
  }

  // Quick-add buttons
  on(document, 'click', function(e) {
    var btn = e.target.closest('.product-card__quick-add');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.dataset.variantId;
    if (!btn.dataset.originalText) btn.dataset.originalText = (btn.textContent || '').trim();
    if (variantId) addToCart(variantId, 1, {}, btn);
  });

  // Add to cart form
  on(document, 'submit', function(e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var variantInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    var submitBtn = form.querySelector('[type="submit"]');
    if (!variantInput) return;
    var variantId = variantInput.value;
    var qty = qtyInput ? parseInt(qtyInput.value) : 1;
    if (submitBtn) submitBtn.dataset.originalText = submitBtn.textContent;
    addToCart(variantId, qty, {}, submitBtn);
  });

  // ---- Search Drawer ----
  var searchDrawer = $('#SearchDrawer');
  var searchInput = $('#SearchInput');

  function openSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.add('open');
    setTimeout(function() { if (searchInput) searchInput.focus(); }, 100);
  }
  function closeSearch() {
    if (!searchDrawer) return;
    searchDrawer.classList.remove('open');
  }

  on($('#SearchToggle'), 'click', openSearch);
  on($('#SearchDrawerClose'), 'click', closeSearch);
  on(document, 'keydown', function(e) { if (e.key === 'Escape') { closeCart(); closeSearch(); } });

  // ---- Hero Slider ----
  // Handled by the single slider at the bottom of this file, which uses the
  // .is-active class the markup and CSS are built around. A second slider
  // used to live here and fought it for control of the same arrows: one
  // click advanced two slides and broke the fade.

  // ---- Drag-to-scroll Carousels ----
  $$('.carousel-track-wrap').forEach(function(wrap) {
    var isDown = false;
    var startX;
    var scrollLeft;
    on(wrap, 'mousedown', function(e) { isDown = true; wrap.classList.add('dragging'); startX = e.pageX - wrap.offsetLeft; scrollLeft = wrap.scrollLeft; });
    on(wrap, 'mouseleave', function() { isDown = false; wrap.classList.remove('dragging'); });
    on(wrap, 'mouseup', function() { isDown = false; wrap.classList.remove('dragging'); });
    on(wrap, 'mousemove', function(e) { if (!isDown) return; e.preventDefault(); var x = e.pageX - wrap.offsetLeft; var walk = (x - startX) * 2; wrap.scrollLeft = scrollLeft - walk; });

    // Nav buttons
    var section = wrap.closest('.carousel-section');
    if (section) {
      var prevBtn = section.querySelector('.carousel-nav__btn--prev');
      var nextBtn = section.querySelector('.carousel-nav__btn--next');
      var track = wrap.querySelector('.carousel-track');
      on(prevBtn, 'click', function() { wrap.scrollBy({ left: -280, behavior: 'smooth' }); });
      on(nextBtn, 'click', function() { wrap.scrollBy({ left: 280, behavior: 'smooth' }); });
    }
  });

  // ---- Product Gallery Thumbnails ----
  var gallery = $('.product-gallery');
  if (gallery) {
    var mainImg = gallery.querySelector('.product-gallery__main img');
    var thumbs = $$('.product-gallery__thumb', gallery);
    thumbs.forEach(function(thumb) {
      on(thumb, 'click', function() {
        thumbs.forEach(function(t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        if (mainImg) {
          var fullSrc = thumb.getAttribute('data-full-src');
          var altText = thumb.getAttribute('data-alt');
          mainImg.src = fullSrc || thumb.querySelector('img').src;
          if (altText) mainImg.alt = altText;
        }
      });
    });
  }

  // ---- Product Tabs ----
  $$('.product-info__tab-btn').forEach(function(btn) {
    on(btn, 'click', function() {
      var tabId = btn.dataset.tab;
      $$('.product-info__tab-btn').forEach(function(b) { b.classList.remove('active'); });
      $$('.product-info__tab-content').forEach(function(c) { c.classList.remove('active'); });
      btn.classList.add('active');
      var content = document.getElementById('Tab-' + tabId);
      if (content) content.classList.add('active');
    });
  });

  // ---- Back to Top ----
  var backToTop = $('#BackToTop');
  var siteHeader = $('#SiteHeader');
  var scrollQueued = false;

  function onScroll() {
    var y = window.scrollY;
    if (backToTop) backToTop.style.display = y > 400 ? 'flex' : 'none';
    if (siteHeader) siteHeader.classList.toggle('scrolled', y > 10);
    scrollQueued = false;
  }

  on(window, 'scroll', function() {
    if (scrollQueued) return;
    scrollQueued = true;
    window.requestAnimationFrame(onScroll);
  }, { passive: true });
  onScroll();

  on(backToTop, 'click', function() {
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });

  // ---- Variant Selector ----
  on(document, 'change', function(e) {
    var select = e.target.closest('[data-variant-select]');
    if (!select) return;
    var form = select.closest('[data-product-form]');
    if (!form) return;
    var variantId = select.value;
    var hiddenInput = form.querySelector('[name="id"]');
    if (hiddenInput) hiddenInput.value = variantId;
  });

  // ---- Intersection Observer for animations ----
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    $$('[data-animate]').forEach(function(el) { observer.observe(el); });
  }

  // ---- Cart page: stop quantity edits being thrown away ----
  // The +/- buttons only change the number on screen, and Checkout is a plain
  // link to /checkout that skips the cart form entirely. So setting a quantity
  // to 3 and pressing Checkout checked you out with 1. This submits the form
  // (which saves the quantities) and lets Shopify continue to checkout.
  on(document, 'click', function(e) {
    var link = e.target.closest('a[href="/checkout"], a[href$="/checkout"]');
    if (!link) return;
    var form = link.closest('form[action*="/cart"]');
    if (!form) return;                      // cart drawer — nothing to save
    if (!form.querySelector('[name="updates[]"]')) return;
    e.preventDefault();
    var go = document.createElement('input');
    go.type = 'hidden';
    go.name = 'checkout';
    go.value = '1';
    form.appendChild(go);
    form.submit();
  });

  // Pressing Enter in a quantity box should update the cart, not checkout.
  on(document, 'keydown', function(e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('input[name="updates[]"]');
    if (!input) return;
    e.preventDefault();
    var form = input.closest('form');
    var update = form && form.querySelector('[name="update"]');
    if (update) update.click();
  });

  // ---- Init ----
  fetchCart();

})();

  // ============================================================
  // TRANSPARENT HEADER — becomes solid on scroll
  // ============================================================
  (function() {
    var header = document.getElementById('SiteHeader');
    if (!header) return;
    var isTransparent = header.classList.contains('site-header--transparent');
    if (!isTransparent) return;

    // Add body class so hero can fill viewport
    document.body.classList.add('has-transparent-header');

    function onScroll() {
      if (window.scrollY > 60) {
        header.classList.add('is-solid');
      } else {
        header.classList.remove('is-solid');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  // ============================================================
  // HERO BANNER SLIDER
  // ============================================================
  (function() {
    var banner = document.getElementById('HeroBanner');
    if (!banner) return;
    var slides = Array.from(banner.querySelectorAll('.hero-banner__slide'));
    if (slides.length <= 1) return;

    var current = 0;
    var autoplayTimer = null;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }

    function startAutoplay() {
      autoplayTimer = setInterval(next, 5000);
    }
    function stopAutoplay() {
      clearInterval(autoplayTimer);
    }

    var btnNext = document.getElementById('HeroNext');
    var btnPrev = document.getElementById('HeroPrev');
    if (btnNext) btnNext.addEventListener('click', function() { stopAutoplay(); next(); startAutoplay(); });
    if (btnPrev) btnPrev.addEventListener('click', function() { stopAutoplay(); prev(); startAutoplay(); });

    // Touch swipe support
    var touchStartX = 0;
    banner.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    banner.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) { stopAutoplay(); diff > 0 ? next() : prev(); startAutoplay(); }
    }, { passive: true });

    startAutoplay();
  })();

// end of yoome.js
